import React, { Component } from "react";
import { Form, Select } from "antd";
import { FormComponentProps } from "antd/lib/form";
import axios from "../lib/api.request";
interface iState {
  data: Array<any>;
}
function getUrlParam() {
  let url = window.location.search;
  let objRequest = {};
  if (url.indexOf("?") !== -1) {
    url = url.split("?")[1];
    let strArr = url.split("&");
    for (let i = 0; i < strArr.length; i++) {
      objRequest[strArr[i].split("=")[0]] = decodeURI(strArr[i].split("=")[1]);
    }
  }
  return objRequest;
}
interface iProps extends FormComponentProps {
  fieldsName?: object;
  dataApi?: string;
  /** 选项数据 */
  selectList?: Array<any>;
  // 是否可以清除
  allowClear?: boolean;
  /** 默认的选中项 */
  defaultValue?: string;
  /** 指定选中项 */
  value?: string;
  /** 选择完成后的回调 */
  onChange?: (value: any) => void;
  /** 默认值 */
  placeholder?:string
}
const { Option } = Select;

export class commonSelector extends Component<iProps, iState> {
  state: iState = {
    data: [],
  };
  async componentDidMount() {
    let data;
    if (this.props.dataApi) {
      let res = await this.getData();
      data = res.data;
    } else {
      data = this.props.selectList ?? [];
    }
    this.setState({
      data,
    });
  }
  getData = () => {
    return axios.request({
      url: this.props.dataApi, //"https://bs-application-resource.oss-cn-beijing.aliyuncs.com/pc/dynamicUI/d",
      method: "get",
      params: { ...getUrlParam() },
    });
  };
  render() {
 
    return (
      <Select
        placeholder={this.props.placeholder??""}
        onChange={this.props.onChange}
        allowClear={this.props.allowClear}
        value={this.props.value}
        defaultValue={this.props.defaultValue}
      >
        {(this.state.data ?? []).map((item) => (
          <Option
            key={item[this.props.fieldsName["id"]]}
            value={item[this.props.fieldsName["id"]]}
          >
            {/* {item.name} */}
            {item[this.props.fieldsName["name"]]}
          </Option>
        ))}
      </Select>
    );
  }
}

const mapPropsToFields = (props) => {
  return {};
};

export default Form.create({ mapPropsToFields })(commonSelector);
